import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogPropertyComponent } from './dialog-property.component';
import { MaterialModule } from '../material.module';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [DialogPropertyComponent],
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule
  ],
  exports: [
    DialogPropertyComponent
  ]
})
export class DialogPropertyModule { }
